import PrivacyPermissionsOverlay from './PrivacyPermissionsOverlay';
import { SectionEnums, PageEnums } from './PrivacyPermissionsOverlay.Enums';

export { SectionEnums, PageEnums };
export default PrivacyPermissionsOverlay;
